import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Announce from '../assets/images/announce-img.png';
import { getLatestAnnouncement } from "../lib/firestoreContent";

const Announcement = () => {
  const [announcement, setAnnouncement] = useState({
    title: "Announcement",
    message: "It's Finally Here... \nOnline 1 Year Robotics bootcamp. \nProudly Sponsored By XploreSTEMi With Partners Across Africa.",
    ctaLabel: "Join Now!!!",
    ctaUrl: "/register",
  });

  useEffect(() => {
    const loadAnnouncement = async () => {
      try {
        const latestAnnouncement = await getLatestAnnouncement();
        if (latestAnnouncement) {
          setAnnouncement(latestAnnouncement);
        }
      } catch (error) {
        console.error("Unable to load announcement content:", error);
      }
    };

    loadAnnouncement();
  }, []);

  const isExternalCta = announcement.ctaUrl && (announcement.ctaUrl.startsWith("http://") || announcement.ctaUrl.startsWith("https://"));

  return (
    <div className="flex justify-center md:justify-evenly gap-7 md:border border-black md:rounded-[12px] px-[38px] md:px-[10px] lg:px-[38px] py-[45px] md:py-[20px] lg:py-[45px] my-[20px] md:mx-[20px] lg:mx-[90px] bg-[#D1C4FD] md:bg-white md:bg-opacity-0 text-primary md:text-dark mt-[50px] mb-[50px]">
      <div className='hidden md:block'>
        <img src={Announce} alt="" />
      </div>
      <div className='text-center md:text-left'>
        <h3
          className="font-bold text-[27px] sm:text-[40px] md:text-[24px] mb-[8px] lg:mb-[24px] md:text-[#4B4B4B]"
          style={{
            fontFamily : "'Clash Display', sans-serif",
          }}
        >
          {announcement.title}
        </h3>
        <p
          className='text-[16px] sm:text-[20px] md:text-[14px] mb-[24px] w-4/5 m-auto text-[#4B4B4B] md:ml-[unset]'
          style={{
            fontFamily : "'Montserrat', sans-serif",
            whiteSpace: "pre-line",
          }}
        >
          {announcement.message}
        </p>
        <p
          className='text-[16px] mb-[41px] font-semibold text-[black] md:text-black'
          style={{
            fontFamily : "'Montserrat', sans-serif",
          }}
        >
          Click the button to Join the community
        </p>
        <div className='flex justify-center md:justify-end'>
          {isExternalCta ? (
            <a
              href={announcement.ctaUrl}
              target="_blank"
              rel="noopener noreferrer"
              className='btn-md md:btn-sm lg:btn-md font-medium inline-block text-center'
              style={{
                fontFamily : "'Clash Display', sans-serif",
              }}
            >
              {announcement.ctaLabel}
            </a>
          ) : (
            <Link
              to={announcement.ctaUrl || "/register"}
              className='btn-md md:btn-sm lg:btn-md font-medium inline-block text-center'
              style={{
                fontFamily : "'Clash Display', sans-serif",
              }}
            >
              {announcement.ctaLabel}
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default Announcement;
